import React, { lazy, Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import swal from 'sweetalert';
import { Redirect } from "react-router-dom";
//import process.env from '../config.json';
import ReCAPTCHA from "react-google-recaptcha"

import $ from 'jquery';
function VerificationAccount(props) {
	//console.log(props);
	let modal = 2;
	let [RedirectState, setRedirectState] = useState(2);

	let [captchaToken, setCaptchaToken] = useState("");
	const [value, setValue] = useState();
	const [user_id, setuser_id] = useState();
	const [verification_status, setverification_status] = useState();
	const [verification_date_time, setverification_date_time] = useState("");
	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

	function onChange(value) {
		setCaptchaToken(value)
	}

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	useEffect(() => {
		async function getverificationmailstatus() {
			var object = {};
			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/check-verification-status-id`, { method: 'POST', body: JSON.stringify({ "id": props.match.params.id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();
			console.log(body)
			if (body.length > 0) {
				setverification_status(body[0].verification_flag);
				setuser_id(body[0].user_id);
				setverification_date_time(body[0].log_date_time);
			}
		}
		getverificationmailstatus();
	}, [])

	const verify_email = (e) => {

		e.preventDefault();
		var object = {};
		object.id = props.match.params.id;
		setMainSubmitButtonState(true)
		axios.post(`${process.env.REACT_APP_SERVER_URL}/verify-email`, object).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data.operation == "success") {
				swal("Great!", "Your email is successfully verified. ", "success", {
					buttons: {
						continue: {
							text: "OK",
							value: "continue",
						},
					}
				}).then((result) => {
					//console.log(result);
					switch (result) {
						case "continue":
							window.location = `/login`;
							break;
						default:
							window.location = `/login`;
							break;

					}
				});
			}
			else {
				if (res.data.message != "danger") {
					swal("Oops!", res.data.message, "error").then((res) => {
						window.location.reload();
					});
				}
				else {
					swal("Oops!", "something went wrong", "error").then((res) => {
						window.location.reload();
					});
				}
			}
		})
			.catch(function (error) {
				swal("Oops!", "something went wrong", "error").then((res) => {
					window.location.reload();
				});
			});
	}




	return (
		<>
			{
				(RedirectState == 1) ? ((getCookie("lastpage") != "") ? window.location.href = getCookie("lastpage") : window.location.href = "/"
				)
					:
					null
			}
			<div className="d-flex flex-column flex-root" id="kt_app_root">
				<div className="d-flex flex-column flex-lg-row flex-column-fluid">
					<div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2" style={{ "background-image": "url(/assets/media/auth/bg5.jpg)" }}>
						<div className="d-flex flex-column flex-center py-15 px-5 px-md-15 w-100">
							<a href="../../demo1/dist/index.html" className="mb-12">
								<img alt="Logo" src={`${process.env.REACT_APP_LOGO}`} className="h-75px" />
							</a>
							<div class="d-flex flex-column flex-center text-center p-10">
								<div class="card card-flush w-md-650px py-5">
									<div class="card-body py-15 py-lg-20">
										{verification_status === "not verified" &&
											<div className="pt-lg-10 mb-10 text-center">
												<h1 className="fw-bolder fs-2qx text-danger mb-7">Email Not Verified</h1>
												<div className="fs-3 fw-bold text-muted mb-10">
													Your email <span className="fw-bolder text-dark">{user_id}</span> has not been verified yet.
													<br />Please verify to continue using your account.
												</div>

												<div className="text-center mb-10">
													<button
														className="btn btn-lg btn-primary fw-bolder"
														data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
														disabled={mainSubmitButtonState}
														onClick={(e) => { verify_email(e) }}
													>
														Verify Your Email
													</button>
												</div>

												<div className="fs-5">
													<span className="fw-bold text-gray-700">
														You can also resend the verification link from your <a href="/dashboard">dashboard</a>.
													</span>
												</div>
											</div>
										}
										{verification_status === "verified" &&
											<div className="pt-lg-10 mb-10 text-center">
												<h1 className="fw-bolder fs-2qx text-success mb-7">Email Verified</h1>
												<div className="fs-3 fw-bold text-muted mb-10">
													Your email <span className="fw-bolder text-dark">{user_id}</span> has been successfully verified.
												</div>
												<a href="/dashboard" className="btn btn-lg btn-success fw-bolder">Go to Dashboard</a>
											</div>
										}
									</div>
								</div>
							</div>
							<h1 className="text-white fs-2qx fw-bolder text-center mb-7">Fast, Efficient and Productive</h1>

							<div className="text-white fs-base text-center">In this kind of post,
								<a href="#" className="opacity-75-hover text-warning fw-bold me-1">the blogger</a>introduces a person they’ve interviewed
								<br />and provides some background information about
								<a href="#" className="opacity-75-hover text-warning fw-bold me-1">the interviewee</a>and their
								<br />work following this is a transcript of the interview.</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
export default VerificationAccount;